export const RECORD_TYPES = [
  "A", "AAAA", "CNAME", "MX", "NS", "TXT", "SOA", "CAA", "PTR",
  "SRV", "DNSKEY", "DS", "HTTPS", "SVCB",
] as const;
export type RecordType = (typeof RECORD_TYPES)[number];

/**
 * Coerce untrusted input (a ?type= query param, a meta tag) to a real
 * RecordType, falling back to "A".
 *
 * Every page that prefills a type from the URL needs this. WatchForm did not
 * have it and kept a private 8-entry copy of the list, so a link carrying
 * type=PTR produced <select value="PTR"> with no matching option: the browser
 * showed "A" while React state — and the submitted watch — stayed "PTR".
 */
export function normalizeRecordType(value: string | null | undefined): RecordType {
  const up = (value ?? "").trim().toUpperCase();
  return (RECORD_TYPES as readonly string[]).includes(up) ? (up as RecordType) : "A";
}
